import { httpsCallable } from 'firebase/functions'
import { functions } from '@/config/firebase'

export const setPublicState = async (toUserId: string) => {
  try {
    const setPublicStateFunction = httpsCallable(functions, 'set_public_state')
    const result = await setPublicStateFunction({ toUserId })
    return result.data
  } catch (error) {
    console.error('[setPublicState] Error:', error)
    throw error
  }
}

export const removePublicState = async (toUserId: string) => {
  try {
    const removePublicStateFunction = httpsCallable(functions, 'remove_public_state')
    const result = await removePublicStateFunction({ toUserId })
    return result.data
  } catch (error) {
    console.error('[removePublicState] Error:', error)
    throw error
  }
}

export const getPublicState = async (toUserId: string): Promise<{ isPublic: boolean }> => {
  try {
    const getPublicStateFunction = httpsCallable(functions, 'get_public_state')
    const result = await getPublicStateFunction({ toUserId })
    return result.data as { isPublic: boolean }
  } catch (error) {
    console.error('[getPublicState] Error:', error)
    throw error
  }
}
